// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__qqFQz","notification-dot":"NotificationDot_notification-dot__+IeHX"};